export default __webpack_public_path__ + "static/media/zdh_3d_01.01cabf98.webp";